import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, RootState, store } from './store.js';

/** Typed react-redux hooks. Components use these, never the untyped originals. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<typeof store>();
